/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

import { useHotel2 } from '../../../../app/contexts/HotelContext'
import { KTSVG } from '../../../helpers'
// import {Dropdown1} from '../../content/dropdown/Dropdown1'

type Props = {
  className: string,
  label1: string,
  value1: string,
  label2: string,
  value2: string,
  label3: string,
  value3: string,
  hotelId: string,
  hotelName: string,
  latestWeeklyWrapUpReportId: number,
  latestDocumentLibraryId: number,
  latestEOMLibraryId: number,
  latestLinenInventoryReportId: number,
  latestPayrollReportId: number,
  setHotelID: (id: string) => {}
  setHotelName: (name: string) => {}
}

const ListsWidget6: React.FC<Props> = (
  { className, value1, value2, value3, label1, label2, label3, hotelId, hotelName, setHotelID, setHotelName, latestWeeklyWrapUpReportId, latestDocumentLibraryId, latestEOMLibraryId,
    latestLinenInventoryReportId, latestPayrollReportId
  }
) => {

  const history = useHistory();




  const setHotel = () => {
    setHotelID(hotelId)
    setHotelName(hotelName)

  }


  const onLinenInventoryTabClick = () => {
    if (latestLinenInventoryReportId != 0) {
      setHotel()

      history.push(`/linenInventories/Details/${latestLinenInventoryReportId}`)

    } else {
      toast.info('No report Found', { position: toast.POSITION.TOP_RIGHT });
    }

  }

  const onPayrollReportTabClick = () => {
    if (latestPayrollReportId != 0) {
      setHotel()

      history.push(`/payrollReport/Details/${latestPayrollReportId}`)

    } else {
      toast.info('No report Found', { position: toast.POSITION.TOP_RIGHT });
    }

  }

  const onEOMTabClick = () => {
    if (latestEOMLibraryId != 0) {
      setHotel()

      history.push(`/eomLibrary/details/${latestEOMLibraryId}`)

    } else {
      toast.info('No report Found', { position: toast.POSITION.TOP_RIGHT });
    }

  }


  const onWeeklyWrapUpClick = () => {
    if (latestWeeklyWrapUpReportId != 0) {
      setHotel()

      history.push(`/weeklyWrapUp/Details/${latestWeeklyWrapUpReportId}`)
    } else {
      toast.info('No report Found', { position: toast.POSITION.TOP_RIGHT });
    }

  }

  const onBankDepositClick = () => {
    if (latestWeeklyWrapUpReportId != 0) {


      setHotel()
      history.push({ pathname: `/weeklyWrapUp/Details/${latestWeeklyWrapUpReportId}`, state: { ActiveTab: "Deposit" } })
    } else {
      toast.info('No report Found', { position: toast.POSITION.TOP_RIGHT });
    }


  }

  const onDocumentLibraryClick = () => {
    if (latestDocumentLibraryId != 0) {

      setHotel()
      history.push(`/documentLibrary/details/${latestDocumentLibraryId}`)

    } else {
      toast.info('No report Found', { position: toast.POSITION.TOP_RIGHT });
    }


  }



  return (
    <div className=''>
      {/* begin::Header */}
      {/* <div className='card-header border-0'>
        <h3 className='card-title fw-bolder text-dark'>Notifications</h3>
        <div className='card-toolbar'> */}
      {/* begin::Menu */}
      {/* <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
          </button>
          <Dropdown1 /> */}
      {/* end::Menu */}
      {/* </div>
      </div> */}
      {/* end::Header */}
      {/* begin::Body */}
      <div className='pt-2'>
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-warning rounded m-2 p-5'
          style={{
            cursor: 'pointer'
          }}
          onClick={onPayrollReportTabClick}

        >
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-warning me-5'>
            <KTSVG path='/media/icons/duotune/hotelRooms/door-dark.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <a className='fw-bolder text-gray-800 text-hover-primary fs-6'>
              {value2}
            </a>
            <span className='text-muted fw-bold d-block'>{label2}</span>
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          {/* <span className='fw-bolder text-warning py-1'>+28%</span> */}
          {/* end::Lable */}
        </div>
        {/* end::Item */}
        {/* begin::Item */}
        {/* <div className='d-flex align-items-center bg-light-success rounded m-2 p-3'> */}
        {/* begin::Icon */}
        {/* <span className='svg-icon svg-icon-success me-5'>

            <KTSVG path='/media/icons/duotune/hotelRooms/houses-fill-dark.svg' className='svg-icon-1' />
          </span> */}
        {/* end::Icon */}
        {/* begin::Title */}
        {/* <div className='flex-grow-1 me-2'>
            <a  className='fw-bolder text-gray-800 text-hover-primary fs-6'>
              {value2}
            </a>
            <span className='text-muted fw-bold d-block'>{label2}</span>
          </div> */}
        {/* end::Title */}
        {/* begin::Lable */}
        {/* <span className='fw-bolder text-success py-1'>+50%</span> */}
        {/* end::Lable */}
        {/* </div> */}
        {/* end::Item */}
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-danger rounded m-2 p-3'
          style={{
            cursor: 'pointer', padding: '25px 10px 25px 10px'
          }}
          onClick={onLinenInventoryTabClick}
        >
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-danger me-5'>
            <KTSVG path='/media/icons/duotune/abstract/abs027.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <a className='fw-bolder text-gray-800 text-hover-primary fs-6'>
              {value3}
            </a>
            <span className='text-muted fw-bold d-block'>{label3}</span>
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          {/* <span className='fw-bolder text-danger py-1'>-27%</span> */}
          {/* end::Lable */}
        </div>
        {/* end::Item */}
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-info rounded m-2' style={{
          cursor: 'pointer', padding: '25px 10px 25px 10px'
        }} onClick={onWeeklyWrapUpClick}>
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-info me-5'>
            <KTSVG path='/media/icons/duotune/calendar/calendar4-dark.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <a className='fw-bolder text-gray-800 text-hover-primary fs-6'>
              {'Latest WeeklyWrapUp'}
            </a>
            {/* <span className='text-muted fw-bold d-block'>{label4}</span> */}
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          {/* <span className='fw-bolder text-info py-1'>+8%</span> */}
          {/* end::Lable */}
        </div>
        {/* end::Item */}

        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-primary rounded m-2'
          style={{
            cursor: 'pointer', padding: '25px 10px 25px 10px'
          }}
          onClick={onBankDepositClick}
        >
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-primary me-5'>
            <KTSVG path='/media/icons/duotune/files/fil009.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <a
              className='fw-bolder text-gray-800 text-hover-primary fs-6'>
              {'Latest Bank Deposit Files'}
            </a>
            {/* <span className='text-muted fw-bold d-block'>{label4}</span> */}
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          {/* <span className='fw-bolder text-info py-1'>+8%</span> */}
          {/* end::Lable */}
        </div>
        {/* end::Item */}
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-dark rounded m-2'
          style={{
            cursor: 'pointer', padding: '25px 10px 25px 10px'
          }}
          onClick={onDocumentLibraryClick}
        >
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-dark me-5'>
            <KTSVG path='/media/icons/duotune/files/fil023.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <a className='fw-bolder text-gray-800 text-hover-primary fs-6'>
              {'Latest Document Library'}
            </a>
            {/* <span className='text-muted fw-bold d-block'>{label4}</span> */}
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          {/* <span className='fw-bolder text-info py-1'>+8%</span> */}
          {/* end::Lable */}
        </div>
        {/* end::Item */}
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-success rounded m-2'
          style={{
            cursor: 'pointer', padding: '25px 10px 25px 10px'
          }}
          onClick={onEOMTabClick}
        >
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-success me-5'>
            <KTSVG path='/media/icons/duotune/files/fil009.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <a className='fw-bolder text-gray-800 text-hover-primary fs-6'>
              {'Latest EOM'}
            </a>
            {/* <span className='text-muted fw-bold d-block'>{label4}</span> */}
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          {/* <span className='fw-bolder text-info py-1'>+8%</span> */}
          {/* end::Lable */}
        </div>
        {/* end::Item */}


      </div>
      {/* end::Body */}
    </div>
  )
}

export { ListsWidget6 }
